import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

$(function(){
    $('.auto_slider').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        speed: 15000,
        variableWidth: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

    
});

